import PropTypes from 'prop-types'
import React from 'react'
import Button from '../../shared/components/Button'

export default function ReleaseInfo({ user, onTogglePreview }) {
  return (
    <div className="horizontal fixed">
      <h1 className="stretch">
        Freigabe von Änderungen
      </h1>

      <div
        className="box fixed"
        style={{ marginRight: '50px' }}
      >
        <Button
          className="btn btn-default"
          onClick={onTogglePreview}
        >
          Vorschau
        </Button>
        &nbsp;
        Verantwortliche:
        {' '}
        <a href={`mailto:${user.email}`}>
          {user.firstname}
          {' '}
          {user.surname}
        </a>

      </div>

    </div>
  )
}

ReleaseInfo.propTypes = {
  onTogglePreview: PropTypes.func,
  user: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseInfo.js